import script from "./SideInternalChat.vue?vue&type=script&setup=true&lang=js"
export * from "./SideInternalChat.vue?vue&type=script&setup=true&lang=js"

import "./SideInternalChat.vue?vue&type=style&index=0&id=7b48e33e&lang=scss&scoped=true"
import "./SideInternalChat.vue?vue&type=style&index=1&id=7b48e33e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b48e33e"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QField from 'quasar/src/components/field/QField.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QInput,QIcon,QSeparator,QBadge,QItemLabel,QExpansionItem,QCard,QCardSection,QInfiniteScroll,QSpinnerDots,QChatMessage,QCircularProgress,QFile,QBtn,QTabPanel,QField});qInstall(script, 'directives', {Ripple});
